import React, { useState, useEffect,useRef } from 'react';
import Footer from '../layout/Footer';
import ViewProduct from './ViewProduct';
import NewProduct from './NewProduct';
import ImportProduct from './ImportProduct';
import ImportBranchProduct from './ImportBranchProduct';
import MyStore from './MyStore';
import { getFromAPI } from '../../Utils/utils';
import { Container, Row, Col, Card, Form, Nav, ToastContainer } from 'react-bootstrap';
import SimpleBarReact from "simplebar-react";
import { productContext } from './productContext';
import { ProductProvider, useProduct } from './getProductData';

// table-data page
import ProductTableData from "./product-data.json";

// icon
import Icon from '@mdi/react';
import { mdiMagnify, mdiPackageVariant, mdiPlus, mdiApplicationImport, mdiPrinterOutline } from '@mdi/js';


function Product(props) {
    const { productData, fetchproductData1 } = useProduct();
    const [selectedProductId, setSelectedProductId] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [showProduct, setShowProduct] = useState(false);
    const [key, setKey] = React.useState(0);

    const myStoreDetails = event => {
        document.getElementById("view-product").classList.remove('d-none');
        document.getElementById("my-store").classList.add('d-none');
    }

    useEffect(() => {
        fetchproductData1();
    }, [selectedProductId]);

    const filteredProductData = productData.filter(customer =>
        customer.description.toLowerCase().includes(searchTerm.toLowerCase())
    );

    useEffect(() => {
        const sidebarItems = document.querySelectorAll(".left-link-item"); // Use querySelectorAll for better targeting
    
        // Loop over all sidebar items
        sidebarItems.forEach((item) => {
            item.addEventListener('click', function () {
                // Remove active class from all sidebar links
                const activeLink = document.querySelector(".left-link-item a.active");
                if (activeLink) activeLink.classList.remove("active");
    
                // Add active class to the clicked item
                const link = this.querySelector('a');
                if (link) link.classList.add('active');
    
                // Update selected vendor ID
                const vendorId = this.getAttribute('data-id');
                setSelectedProductId(vendorId);
                setShowProduct(false);

                // Trigger click on the "View Vendor" tab
                const viewVendorTab = document.getElementById("pills-view-product-tab");
                if (viewVendorTab) {
                    viewVendorTab.click();  // Ensure the tab is switched programmatically
                }
    
            });
        });
    
        // Cleanup listeners on component unmount
        return () => {
            sidebarItems.forEach((item) => {
                item.removeEventListener('click', () => {});
            });
        };
    }, [filteredProductData]);

    // Set default selected product to the first product if no product is selected
    useEffect(() => {
        if (productData.length > 0 && (!selectedProductId || !productData.some(c => c.id === selectedProductId))) {
            setSelectedProductId(productData[0].id);
        }
    }, [productData]);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };
    // Left list data

    const handleNewProductSuccess = (newProductId) => {
        fetchproductData1();
        setSelectedProductId(newProductId);
        setShowProduct(false);
        
        // Switch to view customer tab
        const viewTab = document.getElementById("pills-view-product-tab");
        if (viewTab) viewTab.click();
    
    };

    const handleNewProductClick = () => {
        setShowProduct(true);
        setKey(prevKey => prevKey + 1);
    };

    const searchInputRef = useRef(null);
           
    useEffect(() => {
            if (searchInputRef.current) {
                searchInputRef.current.focus();
            }
    }, []);
    
    return (
        <>
            <productContext.Provider value={selectedProductId}>
                <div className="page-wrapper">
                    <div className='page-content'>
                        <Container>
                            <Row>
                                <Col>
                                    <Card>
                                        <Card.Body>
                                            <div className='d-xl-flex justify-content-between align-items-center'>
                                                <Form className='custom-form-width'>
                                                    <div className='custom-search-bar'>
                                                        <Icon path={mdiMagnify} size={1} className="custom-search-input-icon" />
                                                        <Form.Control className=''
                                                            type="text"
                                                            placeholder={`Search product name from ${filteredProductData.length} products...`}
                                                            name='productSearch'
                                                            id='productSearch'
                                                            onChange={handleSearchChange}
                                                            value={searchTerm}
                                                            ref = {searchInputRef}
                                                        />
                                                    </div>
                                                </Form>
                                                <div className="custom-top-nav-tab mt-3 mt-xl-0">
                                                    <ul className="nav nav-pills btn-list" id="pills-tab" role="tablist">
                                                        <li className="nav-item" role="presentation">
                                                            <button className="nav-link active" onClick={myStoreDetails} id="pills-view-product-tab" data-bs-toggle="pill" data-bs-target="#pills-view-product" type="button" role="tab" aria-controls="pills-view-product" aria-selected="true">
                                                                <Icon path={mdiPackageVariant} className="btn-icon me-1" />View Product
                                                            </button>
                                                        </li>
                                                        <li className="nav-item" role="presentation">
                                                            <button className={`nav-link ${showProduct ? 'active' : ''}`} id="pills-new-product-tab" data-bs-toggle="pill" data-bs-target="#pills-new-product" type="button" role="tab" aria-controls="pills-new-product" aria-selected="false" onClick={handleNewProductClick}>
                                                                <Icon path={mdiPlus} className="btn-icon me-1" />New Product
                                                            </button>
                                                        </li>
                                                        <li className="nav-item" role="presentation">
                                                            <button className="nav-link" id="pills-import-product-tab" data-bs-toggle="pill" data-bs-target="#pills-import-product" type="button" role="tab" aria-controls="pills-import-product" aria-selected="false">
                                                                <Icon path={mdiApplicationImport} className="btn-icon me-1" />Import Product
                                                            </button>
                                                        </li>
                                                        <li className="nav-item" role="presentation">
                                                            <button className="nav-link" id="pills-import-branch-product-tab" data-bs-toggle="pill" data-bs-target="#pills-import-branch-product" type="button" role="tab" aria-controls="pills-import-branch-product" aria-selected="false">
                                                                <Icon path={mdiApplicationImport} className="btn-icon me-1" />Import Branch Product
                                                            </button>
                                                        </li>
                                                        {/* <li className="nav-item" role="presentation">
                                                            <button className="nav-link" id="pills-print-all-barcode-tab" type="button" role="tab" aria-selected="false">
                                                                <Icon path={mdiPrinterOutline} className="btn-icon me-1" />Print All Barcode
                                                            </button>
                                                        </li> */}
                                                    </ul>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg={4} xxl={3}>
                                    <Card className='procust-left-list leftbar-list'>
                                        <SimpleBarReact>
                                            <Card.Body>
                                                <div className='left-list-bar'>
                                                    {filteredProductData
                                                        .map((data, i) => (
                                                            <Nav.Item className='left-link-item' key={i} data-id={data.id} onClick={() => setSelectedProductId(data.id)}> {/* Add data-id attribute */}
                                                                <Nav.Link className={data.id === selectedProductId ? "active" : ""}>
                                                                    <h5 className='product-tab-title'>{data.description}</h5>
                                                                </Nav.Link>
                                                            </Nav.Item>
                                                        ))}
                                                </div>

                                            </Card.Body>
                                        </SimpleBarReact>
                                    </Card>
                                </Col>
                                <Col lg={8} xxl={9}>
                                    <div className="tab-content" id="pills-tabContent">
                                        {/* view-product start */}
                                        <div className={`tab-pane fade ${!showProduct ? 'show active' : ''}`} id="pills-view-product" role="tabpanel" aria-labelledby="pills-view-product-tab" tabIndex="0">
                                            <MyStore />
                                            <ViewProduct setSelectedProductId= {setSelectedProductId}/>
                                        </div> {/* view-product end */}

                                        {/* new-product start */}
                                        <div className={`tab-pane fade ${showProduct ? 'show active' : ''}`} id="pills-new-product" role="tabpanel" aria-labelledby="pills-new-product-tab" tabIndex="0">
                                            <NewProduct key={key} onSuccess={handleNewProductSuccess}/>
                                        </div> {/* new-product end */}

                                        {/* import-product start */}
                                        <div className="tab-pane fade" id="pills-import-product" role="tabpanel" aria-labelledby="pills-import-product-tab" tabIndex="0">
                                            <ImportProduct />
                                        </div> {/* import-product end */}

                                        {/* import-branch-product start */}
                                        <div className="tab-pane fade" id="pills-import-branch-product" role="tabpanel" aria-labelledby="pills-import-branch-product-tab" tabIndex="0">
                                            <ImportBranchProduct />
                                        </div> {/* import-branch-product END */}
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <Footer />
                </div>
            </productContext.Provider>
        </>
    )
}

export default function CustomersWithProvider() {
    return (
        <>
        <ProductProvider>
            <Product />
        </ProductProvider>
        </>
    );
}